import Tooltip from './Tooltip'

export { TooltipNameType } from './Tooltip'
export { Tooltip }
export default Tooltip
